import { Data } from "./Data";
import { About } from "./About";
import { Ped } from "./Ped";

const dashboardNew = {
  Data,
  About,
  Ped
}

export default dashboardNew